export const closeSearchInput = () => {
    const element = document.querySelector(
        '.zoneeditmodal-assignvehiclesblock .assignvehiclelabel'
    );
    const mouseEvent = new MouseEvent('mousedown', {
        bubbles: true
    });
    element?.dispatchEvent(mouseEvent);
};
